<template>
  <div class="cases-page">
    <!-- Page Header -->
    <section class="page-hero">
      <div class="container">
        <h1 class="hero-title">客户案例</h1>
        <p class="hero-subtitle">与知名企业携手并进，共创数字化成功之路</p>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="stats-section">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">1000+</div>
            <div class="stat-label">服务客户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">98%</div>
            <div class="stat-label">客户满意度</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">50+</div>
            <div class="stat-label">行业覆盖</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">24/7</div>
            <div class="stat-label">技术支持</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Client Logos -->
    <section class="clients-section">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <p class="section-subtitle">众多知名企业选择我们作为数字化转型伙伴</p>
        
        <div class="clients-grid">
          <div class="client-logo" v-for="client in clients" :key="client.id">
            <img :src="client.logo" :alt="client.name" />
            <span class="client-name">{{ client.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Featured Cases -->
    <section class="featured-cases">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <p class="section-subtitle">深入了解我们如何帮助客户实现业务增长</p>
        
        <div class="cases-grid">
          <div class="case-card" v-for="case_item in featuredCases" :key="case_item.id">
            <div class="case-image">
              <img :src="case_item.image" :alt="case_item.title" />
              <div class="case-category">{{ case_item.category }}</div>
            </div>
            <div class="case-content">
              <h3 class="case-title">{{ case_item.title }}</h3>
              <p class="case-description">{{ case_item.description }}</p>
              <div class="case-results">
                <div class="result-item" v-for="result in case_item.results" :key="result.label">
                  <span class="result-value">{{ result.value }}</span>
                  <span class="result-label">{{ result.label }}</span>
                </div>
              </div>
              <div class="case-tags">
                <span class="tag" v-for="tag in case_item.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Industry Cases -->
    <section class="industry-cases">
      <div class="container">
        <h2 class="section-title">行业解决方案</h2>
        <p class="section-subtitle">针对不同行业提供专业的数字化解决方案</p>
        
        <div class="industry-tabs">
          <div 
            class="tab-item" 
            v-for="industry in industries" 
            :key="industry.id"
            :class="{ active: activeIndustry === industry.id }"
            @click="activeIndustry = industry.id">
            {{ industry.name }}
          </div>
        </div>
        
        <div class="industry-content">
          <div v-for="industry in industries" :key="industry.id" v-show="activeIndustry === industry.id">
            <div class="industry-layout">
              <div class="industry-info">
                <h3 class="industry-title">{{ industry.name }}解决方案</h3>
                <p class="industry-description">{{ industry.description }}</p>
                <ul class="industry-features">
                  <li v-for="feature in industry.features" :key="feature">{{ feature }}</li>
                </ul>
                <div class="industry-clients">
                  <h4>典型客户</h4>
                  <div class="client-list">
                    <span v-for="client in industry.clients" :key="client" class="client-tag">{{ client }}</span>
                  </div>
                </div>
              </div>
              <div class="industry-visual">
                <img :src="industry.image" :alt="industry.name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="testimonials-section">
      <div class="container">
        <h2 class="section-title">客户评价</h2>
        <p class="section-subtitle">听听客户对我们的真实评价</p>
        
        <div class="testimonials-grid">
          <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
            <div class="testimonial-content">
              <div class="quote-icon">"</div>
              <p class="testimonial-text">{{ testimonial.content }}</p>
            </div>
            <div class="testimonial-author">
              <img :src="testimonial.avatar" :alt="testimonial.name" class="author-avatar" />
              <div class="author-info">
                <h4 class="author-name">{{ testimonial.name }}</h4>
                <p class="author-position">{{ testimonial.position }}</p>
                <p class="author-company">{{ testimonial.company }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">准备开始您的数字化之旅？</h2>
          <p class="cta-description">联系我们，了解如何为您的企业定制专属的数字化解决方案</p>
          <div class="cta-buttons">
            <button class="btn-primary" @click="handleContact">立即咨询</button>
            <button class="btn-outline" @click="handleDemo">预约演示</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CasesPage',
  data() {
    return {
      activeIndustry: 1,
      clients: [
        { id: 1, name: '搜狐视频', logo: 'https://gips3.baidu.com/it/u=3900219912,4233956416&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=F29725641DD019D49290659903005082' },
        { id: 2, name: '华策影视', logo: 'https://gips2.baidu.com/it/u=2812215542,4214337705&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=3357887616618B4B04AB6FAF0300B00E' },
        { id: 3, name: '快看漫画', logo: 'https://t7.baidu.com/it/u=3757741410,634436923&fm=190&app=131&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=6DEDAE46D79C899003C732360300004C' },
        { id: 4, name: '网易', logo: 'https://t7.baidu.com/it/u=3338377718,161067460&fm=190&app=131&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=7B678856C4ACA91314A72FED0300701E' },
        { id: 5, name: '芒果TV', logo: 'https://t7.baidu.com/it/u=3338377718,161067460&fm=190&app=131&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=7B678856C4ACA91314A72FED0300701E' },
        { id: 6, name: '中国移动', logo: 'https://t9.baidu.com/it/u=2314614222,4149755749&fm=74&app=80&size=f256,256&n=0&f=JPEG&fmt=auto?s=E1B60472190ECECE4E69A1C60000C0B2&sec=1752426000&t=2f638facf6505193f8b3dafa2d3bc9b2' },
        { id: 7, name: '河南省羽毛球协会', logo: 'https://gips3.baidu.com/it/u=994598945,2744749495&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=80F4E836466072B053CE02E50300A023' },
        { id: 8, name: '爱奇艺', logo: 'https://bizaladdin-image.baidu.com/0/pic/232755288_-159094242_-771085581.png' }
      ],
      featuredCases: [
        {
          id: 1,
          title: '某头部内容供应商：内容分发效率提升300%',
          description: '通过我们的IPTV C2分发系统，实现了内容分发的自动化管理，大幅提升了分发效率和用户观看体验。',
          image: 'https://picsum.photos/400/300?random=201',
          category: '视频分发',
          results: [
            { value: '300%', label: '分发效率提升' },
            { value: '50%', label: '运营成本降低' },
            { value: '99.9%', label: '系统稳定性' }
          ],
          tags: ['IPTV', '内容分发', '自动化']
        },
        {
          id: 2,
          title: '某连锁门店：用户增长200%',
          description: '借助小红书生态SAAS系统，我们在小红书平台实现了精准营销，用户增长和转化率都有显著提升。',
          image: 'https://picsum.photos/400/300?random=202',
          category: '社交营销',
          results: [
            { value: '200%', label: '用户增长' },
            { value: '150%', label: '转化率提升' },
            { value: '80%', label: '营销效率提升' }
          ],
          tags: ['小红书', 'SAAS', '精准营销']
        },
        {
          id: 3,
          title: '某头部短剧制作公司：数字化转型典范',
          description: '为我们做短剧发行提供全方位的数字化解决方案，包括客户管理、业务流程优化和数据分析平台。',
          image: 'https://picsum.photos/400/300?random=203',
          category: '企业数字化',
          results: [
            { value: '40%', label: '业务效率提升' },
            { value: '60%', label: '客户满意度提升' },
            { value: '30%', label: '运营成本降低' }
          ],
          tags: ['企业管理', '数字化转型', '数据分析']
        }
      ],
      industries: [
        {
          id: 1,
          name: '影视娱乐',
          description: '为影视娱乐行业提供内容分发、用户运营、数据分析等全方位解决方案，助力企业在数字化时代抢占先机。',
          features: [
            '高效的内容分发系统',
            '精准的用户画像分析',
            '多平台统一管理',
            '实时数据监控和分析',
            '个性化推荐算法'
          ],
          clients: ['搜狐视频', '华策影视', '芒果TV', '爱奇艺'],
          image: 'https://picsum.photos/500/350?random=301'
        },
        {
          id: 2,
          name: '互联网科技',
          description: '针对互联网科技企业的快速发展需求，提供敏捷的技术解决方案和专业的运营支持。',
          features: [
            '快速部署和上线',
            '高并发系统架构',
            '数据安全保障',
            '7×24小时技术支持',
            '弹性扩展能力'
          ],
          clients: ['网易', '快看漫画', '小红书', '字节跳动'],
          image: 'https://picsum.photos/500/350?random=302'
        },
        {
          id: 3,
          name: '电信运营商',
          description: '为电信运营商提供企业级的数字化转型解决方案，优化业务流程，提升服务质量。',
          features: [
            '企业级安全保障',
            '大规模用户管理',
            '业务流程自动化',
            '智能客服系统',
            '数据挖掘和分析'
          ],
          clients: ['中国移动', '中国电信', '中国联通'],
          image: 'https://picsum.photos/500/350?random=303'
        },
        {
          id: 4,
          name: '体育组织',
          description: '为体育组织和协会提供会员管理、赛事组织、数据统计等专业化服务。',
          features: [
            '会员管理系统',
            '赛事组织和管理',
            '成绩统计和分析',
            '移动端应用支持',
            '社交互动功能'
          ],
          clients: ['河南省羽毛球协会', '北京篮球协会', '上海足球协会'],
          image: 'https://picsum.photos/500/350?random=304'
        }
      ],
      testimonials: [
        {
          id: 1,
          content: '雪顶科技的IPTV分发系统让我们的内容分发效率提升了3倍，技术团队的专业性和响应速度都非常出色。',
          name: '李总',
          position: '技术总监',
          company: '某知名内容供应商',
          avatar: 'https://picsum.photos/80/80?random=401'
        },
        {
          id: 2,
          content: '在小红书营销方面，他们的短剧系统帮助我们实现了精准投放，ROI提升了150%，非常满意！',
          name: '王总',
          position: '增长运营总监',
          company: '某国内头部动漫公司',
          avatar: 'https://picsum.photos/80/80?random=402'
        },
        {
          id: 3,
          content: '作为央企，我们对技术方案的要求很高。雪顶科技不仅满足了我们的技术需求，还提供了优质的售后服务。',
          name: '张总',
          position: '技术负责人',
          company: '某大型企业',
          avatar: 'https://picsum.photos/80/80?random=403'
        }
      ]
    }
  },
  methods: {
    handleContact() {
      alert('立即咨询功能待开发')
    },
    handleDemo() {
      alert('预约演示功能待开发')
    }
  }
}
</script>

<style scoped>
.cases-page {
  padding-top: 72px;
  min-height: 100vh;
}

.page-hero {
  background: linear-gradient(135deg, #3470ff 0%, #667eea 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 1.2rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  line-height: 1.6;
}

/* Stats Section */
.stats-section {
  padding: 60px 0;
  background: #f8f9fa;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 3rem;
  font-weight: bold;
  color: #3470ff;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1.1rem;
  color: #666;
}

/* Clients Section */
.clients-section {
  padding: 80px 0;
}

.clients-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-top: 40px;
}

.client-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 30px 20px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.client-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.client-logo img {
  width: 120px;
  height: 60px;
  object-fit: contain;
  filter: grayscale(100%);
  transition: filter 0.3s ease;
}

.client-logo:hover img {
  filter: grayscale(0%);
}

.client-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #555;
}

/* Featured Cases */
.featured-cases {
  padding: 80px 0;
  background: #f8f9fa;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.case-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.case-image {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.case-category {
  position: absolute;
  top: 15px;
  left: 15px;
  background: #3470ff;
  color: white;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 0.9rem;
  font-weight: 500;
}

.case-content {
  padding: 30px;
}

.case-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.4;
}

.case-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.case-results {
  display: flex;
  gap: 30px;
  margin-bottom: 25px;
}

.result-item {
  text-align: center;
}

.result-value {
  display: block;
  font-size: 1.8rem;
  font-weight: bold;
  color: #3470ff;
}

.result-label {
  font-size: 0.9rem;
  color: #666;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  background: #f1f3f4;
  color: #555;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.85rem;
}

/* Industry Cases */
.industry-cases {
  padding: 80px 0;
}

.industry-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
  flex-wrap: wrap;
}

.tab-item {
  padding: 12px 30px;
  border-radius: 25px;
  background: #f1f3f4;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.tab-item.active {
  background: #3470ff;
  color: white;
}

.tab-item:hover:not(.active) {
  background: #e9ecef;
  color: #3470ff;
}

.industry-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.industry-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
}

.industry-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  font-size: 1.1rem;
}

.industry-features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.industry-features li {
  padding: 10px 0;
  border-bottom: 1px solid #f1f3f4;
  color: #555;
  position: relative;
  padding-left: 25px;
}

.industry-features li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #3470ff;
  font-weight: bold;
}

.industry-clients h4 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.client-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.client-tag {
  background: linear-gradient(135deg, #3470ff, #667eea);
  color: white;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 0.9rem;
  font-weight: 500;
}

.industry-visual img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

/* Testimonials */
.testimonials-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.testimonial-card {
  background: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.testimonial-content {
  margin-bottom: 30px;
}

.quote-icon {
  font-size: 4rem;
  color: #3470ff;
  opacity: 0.3;
  line-height: 1;
  margin-bottom: 20px;
}

.testimonial-text {
  color: #555;
  line-height: 1.6;
  font-size: 1.1rem;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 15px;
}

.author-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.author-name {
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.author-position {
  color: #3470ff;
  font-size: 0.9rem;
  margin-bottom: 3px;
}

.author-company {
  color: #666;
  font-size: 0.9rem;
}

/* CTA Section */
.cta-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #3470ff 0%, #667eea 100%);
  color: white;
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.cta-description {
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: white;
  color: #3470ff;
  border: none;
  padding: 15px 40px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(255, 255, 255, 0.3);
}

.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 15px 40px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: white;
  color: #3470ff;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .clients-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .industry-layout {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  .cases-grid {
    grid-template-columns: 1fr;
  }
  
  .case-results {
    flex-direction: column;
    gap: 20px;
  }
  
  .industry-tabs {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-primary,
  .btn-outline {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .clients-grid {
    grid-template-columns: 1fr;
  }
  
  .case-content {
    padding: 20px;
  }
  
  .testimonial-card {
    padding: 25px;
  }
  
  .cta-title {
    font-size: 2rem;
  }
}
</style> 